var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatictics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stats_Icon",
    "data-name": "Stats Icon",
    transform: "translate(-48 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M51.365,314H49.442A1.357,1.357,0,0,1,48,312.75v-7.5A1.357,1.357,0,0,1,49.442,304h1.923a1.357,1.357,0,0,1,1.442,1.25v7.5A1.357,1.357,0,0,1,51.365,314Z",
    transform: "translate(0 -273)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M275.365,223h-1.923A1.357,1.357,0,0,1,272,221.75v-12.5a1.357,1.357,0,0,1,1.442-1.25h1.923a1.357,1.357,0,0,1,1.442,1.25v12.5A1.357,1.357,0,0,1,275.365,223Z",
    transform: "translate(-210.538 -182)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M387.365,116.833h-1.923a1.357,1.357,0,0,1-1.442-1.25V97.25A1.357,1.357,0,0,1,385.442,96h1.923a1.357,1.357,0,0,1,1.442,1.25v18.333A1.357,1.357,0,0,1,387.365,116.833Z",
    transform: "translate(-315.808 -75.833)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M163.365,41h-1.923A1.357,1.357,0,0,1,160,39.75V17.25A1.357,1.357,0,0,1,161.442,16h1.923a1.357,1.357,0,0,1,1.442,1.25v22.5A1.357,1.357,0,0,1,163.365,41Z",
    transform: "translate(-105.269)",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatictics);
export default __webpack_public_path__ + "static/media/statictics.a3a5c68137a8154a90cf491e3c0d6fec.svg";
export { ForwardRef as ReactComponent };